// index.ts
import { distance } from "@turf/distance";
import { segmentReduce } from "@turf/meta";
function length(geojson) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return segmentReduce(geojson, function(previousValue, segment) {
        var coords = segment.geometry.coordinates;
        return previousValue + distance(coords[0], coords[1], options);
    }, 0);
}
var turf_length_default = length;
export { turf_length_default as default, length }; //# sourceMappingURL=index.js.map
